<template>
  <div style="padding-bottom: 50px">
    <div class="sub-title">客户寄回</div>
    <el-form
      v-if="
        [
          dictMap['pre_inspection_of_receiving_goods'].id,
          dictMap['to_be_sent_out'].id,
          dictMap['under_repair'].id,
          dictMap['to_be_returned'].id,
        ].includes(receivedInfo.status) || isCreat
      "
      ref="forms"
      :rules="rules"
      :model="receivedInfo"
      label-width="80px"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="物流状态" prop="receivedStatus">
            <el-select
              clearable
              v-model="receivedInfo.receivedStatus"
              placeholder="请选择"
            >
              <el-option
                v-for="item in logisticStatus"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="寄件方式" prop="receivedMethod">
            <el-select
              clearable
              v-model="receivedInfo.receivedMethod"
              placeholder="请选择"
            >
              <el-option
                v-for="item in shippingMethod"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物流单号">
            <el-input
              :disabled="receivedInfo.receivedMethod != dictMap['express'].id"
              maxlength="100"
              show-word-limit
              clearable
              v-model="receivedInfo.receivedCode"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="寄件人信息" prop="receivedCustomerA">
          <el-input
            type="textarea"
            v-model="receivedInfo.receivedCustomerA"
            placeholder="请输入文字描述，限制200字符。"
            :rows="2"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="收件人信息" prop="receivedCustomerB">
          <el-input
            type="textarea"
            v-model="receivedInfo.receivedCustomerB"
            placeholder="请输入文字描述，限制200字符。"
            :rows="2"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="备注" prop="receivedRemarks">
          <el-input
            type="textarea"
            v-model="receivedInfo.receivedRemarks"
            placeholder="请输入文字描述，限制200字符。"
            :rows="2"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <div v-else>
      <el-row :gutter="20">
        <el-col :span="8"
          ><div class="grid-content">
            <span class="label-left">物流状态</span
            ><span class="desc-text">{{
              getRecStatusText(receivedInfo.receivedStatus) || "-"
            }}</span>
          </div></el-col
        >
        <el-col :span="8"
          ><div class="grid-content">
            <span class="label-left">寄件方式</span
            ><span class="desc-text">{{
              getShippingMethodText(receivedInfo.receivedMethod) || "-"
            }}</span>
          </div></el-col
        >
        <el-col :span="8"
          ><div class="grid-content">
            <span class="label-left">物流单号</span
            ><span class="desc-text">{{
              receivedInfo.receivedCode || "-"
            }}</span>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16"
          ><div class="grid-content">
            <span class="label-left">寄件人信息</span
            ><span class="desc-text">{{
              receivedInfo.receivedCustomerA || "-"
            }}</span>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16"
          ><div class="grid-content">
            <span class="label-left">收件人信息</span
            ><span class="desc-text">{{
              receivedInfo.receivedCustomerB || "-"
            }}</span>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16"
          ><div class="grid-content">
            <span class="label-left">备注</span
            ><span class="desc-text">{{
              receivedInfo.receivedRemarks || "-"
            }}</span>
          </div></el-col
        >
      </el-row>
    </div>
    <div class="sub-title">售后发货</div>
    <el-form
      v-if="
        [
          dictMap['pre_inspection_of_receiving_goods'].id,
          dictMap['to_be_sent_out'].id,
          dictMap['under_repair'].id,
          dictMap['to_be_returned'].id,
        ].includes(receivedInfo.status) || isCreat
      "
      ref="form"
      :rules="
        [dictMap['to_be_sent_out'].id, dictMap['to_be_returned'].id].includes(
          orderData.status
        )
          ? rule
          : {}
      "
      :model="shippedInfo"
      label-width="80px"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="发货状态" prop="shippedStatus">
            <el-select
              :disabled="isCreat"
              clearable
              v-model="shippedInfo.shippedStatus"
              placeholder="请选择"
            >
              <el-option
                v-for="item in shippingStatus"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="寄件方式" prop="shippedMethod">
            <el-select
              :disabled="isCreat"
              clearable
              v-model="shippedInfo.shippedMethod"
              placeholder="请选择"
            >
              <el-option
                v-for="item in shippingMethod"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物流单号">
            <el-input
              :disabled="
                isCreat || shippedInfo.shippedMethod != dictMap['express'].id
              "
              maxlength="100"
              show-word-limit
              clearable
              v-model="shippedInfo.shippedCode"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="寄件人信息" prop="shippedCustomerA">
          <el-input
            type="textarea"
            v-model="shippedInfo.shippedCustomerA"
            placeholder="请输入文字描述，限制200字符。"
            :rows="2"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="收件人信息" prop="shippedCustomerB">
          <el-input
            type="textarea"
            v-model="shippedInfo.shippedCustomerB"
            placeholder="请输入文字描述，限制200字符。"
            :rows="2"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="备注" prop="shippedRemarks">
          <el-input
            type="textarea"
            v-model="shippedInfo.shippedRemarks"
            placeholder="请输入文字描述，限制200字符。"
            :rows="2"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <div v-else>
      <el-row :gutter="20">
        <el-col :span="8"
          ><div class="grid-content">
            <span class="label-left">发货状态</span
            ><span class="desc-text">{{
              getShipStatusText(shippedInfo.shippedStatus) || "-"
            }}</span>
          </div></el-col
        >
        <el-col :span="8"
          ><div class="grid-content">
            <span class="label-left">寄件方式</span
            ><span class="desc-text">{{
              getShippingMethodText(shippedInfo.shippedMethod) || "-"
            }}</span>
          </div></el-col
        >
        <el-col :span="8"
          ><div class="grid-content">
            <span class="label-left">物流单号</span
            ><span class="desc-text">{{ shippedInfo.shippedCode || "-" }}</span>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16"
          ><div class="grid-content">
            <span class="label-left">寄件人信息</span
            ><span class="desc-text">{{
              shippedInfo.shippedCustomerA || "-"
            }}</span>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16"
          ><div class="grid-content">
            <span class="label-left">收件人信息</span
            ><span class="desc-text">{{
              shippedInfo.shippedCustomerB || "-"
            }}</span>
          </div></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16"
          ><div class="grid-content">
            <span class="label-left">备注</span
            ><span class="desc-text">{{
              receivedInfo.receivedRemarks || "-"
            }}</span>
          </div></el-col
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import { getDictMap } from "../../../utils/util";
export default {
  name: "reciveandPostInfo",
  props: {
    orderData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isCreat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logisticStatus: [],
      shippingMethod: [],
      shippingStatus: [],
      // editableStatus: [
      //   dictMap["pre_inspection_of_receiving_goods"].id,
      //   dictMap["to_be_sent_out"].id,
      // ],
      receivedInfo: {
        receivedStatus: "",
        receivedMethod: "",
        receivedCode: "",
        receivedCustomerA: "",
        receivedCustomerB: "",
        receivedRemarks: "",
      },
      shippedInfo: {
        shippedStatus: "",
        shippedMethod: "",
        shippedCode: "",
        shippedCustomerA: "",
        shippedCustomerB: "",
        shippedRemarks: "",
      },
      rules: {
        receivedStatus: [
          { required: true, message: "请输入物流状态", trigger: "change" },
        ],
        receivedMethod: [
          { required: true, message: "请输入寄件方式", trigger: "change" },
        ],
        receivedCustomerA: [
          { required: true, message: "请输入寄件人信息", trigger: "blur" },
        ],
        receivedCustomerB: [
          { required: true, message: "请输入收件人信息", trigger: "blur" },
        ],
        // receivedRemarks: [
        //   { required: true, message: "请输入备注", trigger: "blur" },
        // ],
      },
      rule: {
        shippedStatus: [
          { required: true, message: "请输入发货状态", trigger: "change" },
        ],
        shippedMethod: [
          { required: true, message: "请输入寄件方式", trigger: "change" },
        ],
        shippedCustomerA: [
          { required: true, message: "请输入寄件人信息", trigger: "blur" },
        ],
        shippedCustomerB: [
          { required: true, message: "请输入收件人信息", trigger: "blur" },
        ],
        // shippedRemarks: [
        //   { required: true, message: "请输入备注", trigger: "blur" },
        // ],
      },
      dictMap: {},
    };
  },
  created() {
    this.dictMap = getDictMap();
    this.receivedInfo.receivedStatus = this.dictMap["not_received_goods"].id;
  },
  mounted() {
    this.getDict();
    if (this.isCreat) {
      this.rules = {
        receivedStatus: [
          { required: true, message: "请输入物流状态", trigger: "change" },
        ],
        // receivedMethod: [
        //   { required: true, message: "请输入寄件方式", trigger: "change" },
        // ],
      };
    }
  },
  watch: {
    orderData(newVal) {
      if (Object.keys(this.orderData).length !== 0) {
        this.receivedInfo = { ...newVal, receivedCode: newVal.receivedCode };
        this.shippedInfo = {
          shippedStatus: newVal.shippedStatus,
          shippedMethod: newVal.shippedMethod,
          shippedCode: newVal.shippedCode,
          shippedCustomerA: newVal.shippedCustomerA,
          shippedCustomerB: newVal.shippedCustomerB,
          shippedRemarks: newVal.shippedRemarks,
          status: newVal.status,
        };
      }
      if (newVal.status) {
        this.rules = {
          receivedStatus: [
            { required: true, message: "请输入物流状态", trigger: "change" },
          ],
          receivedMethod: [
            { required: true, message: "请输入寄件方式", trigger: "change" },
          ],
          receivedCustomerA: [
            { required: true, message: "请输入寄件人信息", trigger: "blur" },
          ],
          receivedCustomerB: [
            { required: true, message: "请输入收件人信息", trigger: "blur" },
          ],
        };
      }
    },
    "receivedInfo.receivedStatus": function (newval) {
      console.log("hander===", newval);
      if (newval === this.dictMap["received_goods"].id) {
        this.rules = {
          receivedStatus: [
            { required: true, message: "请输入物流状态", trigger: "change" },
          ],
          receivedMethod: [
            { required: true, message: "请输入寄件方式", trigger: "change" },
          ],
          receivedCustomerA: [
            { required: true, message: "请输入寄件人信息", trigger: "blur" },
          ],
          receivedCustomerB: [
            { required: true, message: "请输入收件人信息", trigger: "blur" },
          ],
        };
      } else {
        this.$refs.forms?.clearValidate("receivedMethod");
        this.receivedInfo.receivedMethod = "";
        this.rules = {
          receivedStatus: [
            { required: true, message: "请输入物流状态", trigger: "change" },
          ],
        };
      }
    },
    "receivedInfo.receivedMethod": function (newval) {
      if (this.dictMap[newval]?.code === "self_pickup") {
        this.receivedInfo.receivedCode = "";
      } else if (this.dictMap[newval]?.code === "express") {
        this.receivedInfo.receivedCode = this.orderData.receivedCode;
      }
    },
    "shippedInfo.shippedMethod": function (newval) {
      if (this.dictMap[newval]?.code === "self_pickup") {
        this.shippedInfo.shippedCode = "";
      } else if (this.dictMap[newval]?.code === "express") {
        this.shippedInfo.shippedCode = this.orderData.shippedCode;
      }
    },
  },
  methods: {
    getShipStatusText(id) {
      const type = this.shippingStatus.find((item) => item.id === id);
      return type ? type.name : "";
    },
    getRecStatusText(id) {
      const type = this.logisticStatus.find((item) => item.id === id);
      return type ? type.name : "";
    },
    getShippingMethodText(id) {
      const type = this.shippingMethod.find((item) => item.id === id);
      return type ? type.name : "";
    },
    getDict() {
      this.logisticStatus = this.dictMap["logistics_status"]?.children;

      this.shippingMethod = this.dictMap["shipping_method"]?.children;

      this.shippingStatus = this.dictMap["shipping_status"]?.children;
    },
  },
};
</script>

<style lang="less" scoped>
.sub-title {
  margin: 20px 0;
  font-size: 16px;
  font-weight: 500;
}
::v-deep .el-textarea {
  .el-textarea__inner {
    //background: #f2f3f5;
    // border: none;
  }
}
::v-deep .el-input__count {
  line-height: 12px;
  // background: #f2f3f5 !important;
}
::v-deep .el-input__count-inner {
  line-height: 12px;
  // background: #f2f3f5 !important;
}
.grid-content {
  margin: 12px 0;
  font-weight: 500;
  font-size: 14px;
  color: #86909c;
  display: flex;
  align-items: center;
  input {
    height: 22px;
  }
}
.label-left {
  display: inline-block;
  width: 110px;
}
</style>
